<template>
	<Card title="开户资料" class="app-list">
		<div class="content">
			<Form autocomplete="off" class="form" hide-required-mark label-position="left" ref="form" :model="form" :rules="rule" :label-width="100">
				<FormItem label="开户公司" prop="bank_company">
					<Input v-if="isEdit" v-model="form.bank_company" clearable />
					<span v-else>{{ data.bank_company }}</span>
				</FormItem>
				<FormItem label="开户银行" prop="bank_bankname">
					<Input v-if="isEdit" v-model="form.bank_bankname" clearable />
					<span v-else>{{ data.bank_bankname }}</span>
				</FormItem>
				<FormItem label="支行名称" prop="bank_branchname">
					<Input v-if="isEdit" autocomplete="off" v-model="form.bank_branchname" clearable />
					<span v-else>{{ data.bank_branchname }}</span>
				</FormItem>
				<FormItem label="开户地址" prop="bank_address">
					<Input v-if="isEdit" autocomplete="off" v-model="form.bank_address" clearable />
					<span v-else>{{ data.bank_address }}</span>
				</FormItem>
				<FormItem label="银行账号" prop="bank_account">
					<Input v-if="isEdit" autocomplete="off" v-model="form.bank_account" clearable />
					<span v-else>{{ data.bank_account }}</span>
				</FormItem>
				<FormItem label="开户许可证" prop="bank_permit_img">
					<Input v-if="isEdit" autocomplete="off" v-model="form.bank_permit_img" clearable />
					<img @click="showBigImg('开户许可证',form.bank_permit_img)" class="bankImg" v-else :src="data.bank_permit_img" alt="开户许可证" />
				</FormItem>
			</Form>
		</div>
	</Card>
</template>

<script>
import { getAccountInfo } from '@/service/api.js';
export default {
	data() {
		const validatePhone = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('手机号不能为空'));
			} else if (!/^1[3456789]\d{9}$/.test(value)) {
				callback('手机号格式不正确');
			} else {
				callback();
			}
		};
		return {
			isEdit: false,
			data: {},
			form: {},
			rule: {
				account: [{ required: true, message: '账号不能为空', trigger: 'blur' }],
				phone: [
					{
						required: true,
						validator: validatePhone,
						trigger: 'blur'
					}
				],
				email: [{ required: true, message: '邮箱不能为空', trigger: 'blur' }, { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }],
				password: [{ required: true, message: '密码不能为空', trigger: 'blur' }]
			}
		};
	},
	mounted() {
		// 测试数据，记得删
		// this.form = {
		//   account: "test",
		//   phone: "13900000000",
		//   email: "tgegehre@qq.com",
		//   password: "123456",
		// };
		this.getData();
	},
	methods: {
		getData() {
			let params = {
				id: window.sessionStorage.getItem('proxyId')
			};
			getAccountInfo(params)
				.then(res => {
					let data = res.data;
					console.log(data);
					if (data.code == 0) {
						this.data = data.data;
						this.form = JSON.parse(JSON.stringify(data.data));
					} else {
						this.$Message.error(data.msg);
					}
				})
				.catch(err => {
					console.log(err);
					this.$Message.error('获取失败!');
				});
		},
		handleSubmit(name) {
			this.$refs[name].validate(valid => {
				console.log(valid);
				if (valid) {
					let params = {
						username: this.form.account,
						mobile: this.form.phone,
						email: this.form.email,
						password: this.form.password
					};

					console.log(params, 'params');
					addStore(params)
						.then(res => {
							console.log(res);
							if (res.data.code == 0) {
								this.$Message.success('添加成功!');
								this.$refs[name].resetFields();
							} else {
								 this.$Message.error({
              duration: 3,
              background: true,
              content: res.data.msg||"操作失败！",
            });

							}
						})
						.catch(err => {
							console.log(err);
							this.$Message.error('添加失败!');
						});
				} else {
					this.$Message.error({
						content: '表单内容不正确,请检查表单内容！',
						duration: 5
					});
				}
			});
		},
		handleReset(name) {
			this.$refs[name].resetFields();
		},
		showBigImg(title,src){
			if(src){
				window.open(src)
			}
			
			console.log(src);                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
		}
	}
};
</script>

<style lang="less" scoped>
.app-list {
	flex: 1;
	margin-top: 30px;
	height: max-content;
	.content {
		// padding: 50px;
		padding: 20px;
		background-color: #fff;
		border-radius: 3px;
		// box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.05);
		.form {
			width: 350px;
		}
	}
}
.bankImg {
	width: 300px;
	height: auto;
	// height: 300px;
}
</style>
